// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5822":"b6abeca2","7836":"e6ea528e"}[chunkId] + ".chunk.css";
};